import { ActionReducerMap, State } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { RootState } from './root-store.state';

export const rootReducer: ActionReducerMap<RootState> = {
    router: routerReducer
};
